import { Base } from '@studiometa/js-toolkit';
import FeaturedWorks from '#js/molecules/FeaturedWorks.js';

/**
 * @typedef {{}} ComponentProps
 */

/**
 * Component component.
 * @extends {Base<ComponentProps>}
 */
export default class Home extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Home',
    components: {
      FeaturedWorks,
    },
    refs: ['panel', 'panelPicture', 'innerPanelPicture'],
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    this.nextSection = false;
    this.lastSection = false;
    this.heightToReach = this.$refs.panel.offsetHeight;
    this.featuredHeightToReach = this.heightToReach + this.$refs.innerPanelPicture.offsetHeight;
  }

  /**
   * Scroll detection
   * @param  {object} options y object
   * @param  {object} options.y y object
   * @returns {void}
   */
  scrolled({ y }) {
    if (y >= this.heightToReach && !this.nextSection) {
      this.nextSection = true;
      this.$refs.panelPicture.classList.add('relative');
    }

    if (y <= this.heightToReach && this.nextSection) {
      this.nextSection = false;
      this.$refs.panelPicture.classList.remove('relative');
    }

    if (y >= this.featuredHeightToReach && !this.lastSection) {
      this.lastSection = true;
      this.$children.FeaturedWorks[0].$el.classList.add('relative');
    }

    if (y <= this.featuredHeightToReach && this.lastSection) {
      this.lastSection = false;
      this.$children.FeaturedWorks[0].$el.classList.remove('relative');
    }
  }
}
